import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { Icon } from './Icon';
import styles from './Button.module.css';

/** Renders an <a> for external hrefs, a <Link> for internal routes, else a <button>. */
function resolveElement({ to, href }) {
  if (href) return { Tag: 'a', props: { href, ...(href.startsWith('http') ? { target: '_blank', rel: 'noreferrer' } : {}) } };
  if (to) {
    // Hash-only and cross-page-hash targets still route through Link.
    return { Tag: Link, props: { to } };
  }
  return { Tag: 'button', props: { type: 'button' } };
}

export function Button({
  variant = 'primary', // primary | outline | dark | ghost
  size = 'md',
  to,
  href,
  icon,                // icon name rendered after the label
  block = false,
  className,
  children,
  ...rest
}) {
  const { Tag, props } = resolveElement({ to, href });
  return (
    <Tag
      className={cn(styles.btn, styles[variant], styles[size], block && styles.block, className)}
      {...props}
      {...rest}
    >
      {children}
      {icon && <Icon name={icon} size={20} className={styles.trailing} />}
    </Tag>
  );
}

/** Icon-only circular button: carousel arrows and the blog cards' corner links. */
export function RoundButton({
  variant = 'outline', // outline | primary | dark
  size = 56,
  icon,
  label,
  to,
  href,
  className,
  style,
  ...rest
}) {
  const { Tag, props } = resolveElement({ to, href });
  const variantClass = {
    outline: styles.roundOutline,
    primary: styles.roundPrimary,
    dark: styles.roundDark,
  }[variant];

  return (
    <Tag
      className={cn(styles.round, variantClass, className)}
      style={{ '--round-size': `${size}px`, ...style }}
      aria-label={label}
      {...props}
      {...rest}
    >
      <Icon name={icon} size={Math.round(size * 0.4)} />
    </Tag>
  );
}
